import { UrlParam } from 'enums';

type ParamsFromUrl<T> = {
  search: string;
  param: UrlParam;
  defaultValue: T;
};

export const getParamsFromUrl = <T>({ search, param, defaultValue }: ParamsFromUrl<T>) => {
  const urlSearchParams = new URLSearchParams(search);
  const result = urlSearchParams.get(param);
  return result ? ((decodeURIComponent(result) as unknown) as T) : defaultValue;
};
